import React from 'react'
import { useState } from 'react'
import { Modal, Button, Form, InputGroup, Breadcrumb } from 'react-bootstrap'
import Select from 'react-select'
import { toast } from 'react-toastify'
import CustomLabel from './CustomLabel'
import { addChild } from '../services/Node'


function AddChildModal({ AddChildModalProps }) {
    const { modalDataIndex, closeModalHandler, locales, indexWalk, setTableData, getEntryRecursive, type } = AddChildModalProps
    const [rows, setRows] = useState([{ value: '', locale: locales.filter(item => item.isDefault)[0], id: new Date().toISOString() }])
    const [btnClicked, setBtnClicked] = useState(false)
    const { topTableData } = AddChildModalProps

    const updatedIndexWalk = [...indexWalk, modalDataIndex]
    const tempIndexWalk = [...updatedIndexWalk]
    let tempTableData = [...topTableData]
    const idWalk = []
    const breadItems = [<Breadcrumb.Item key='ROOT' linkAs={CustomLabel}>{type.display}</Breadcrumb.Item>]

    while (tempIndexWalk.length > 0) {
        const current = tempTableData[tempIndexWalk.shift()]
        tempTableData = current.children
        breadItems.push(<Breadcrumb.Item key={current._id} linkAs={CustomLabel}>{current.data[0].name}</Breadcrumb.Item>)
        idWalk.push(current._id)
    }

    const addRowHandler = () => {
        if (rows.length < locales.length)
            setRows([...rows, { value: '', locale: null, id: new Date().toISOString() }])
    }

    const removeRowHandler = (index) => {
        const updatedRows = [...rows]
        updatedRows.splice(index, 1)
        setRows(updatedRows)
    }

    const rowInputChangeHandler = (index, value) => {
        const updatedRows = [...rows]
        updatedRows[index].value = value
        setRows(updatedRows)
    }

    const localesChangeHandler = (selectedOption, index) => {
        if (rows.find((row, i) => (i !== index && row.locale.value === selectedOption.value))) {
            toast.error('This locale has already been selected')
            selectedOption = ''
        }
        const updatedRows = [...rows]
        updatedRows[index].locale = selectedOption
        setRows(updatedRows)
    }

    const addChildBtnHandler = async () => {
        if (btnClicked)
            return
        setBtnClicked(true)
        try {
            // structure of a row element { value: '', locale: { value: 'es', label: 'Spanish', isDefault: undefined } }
            const childData = rows.map(({ value, locale }) => {
                if (value === '')
                    throw new Error('Enter a value')
                const inputLocale = locale?.value
                if (!inputLocale)
                    throw new Error('Select a locale')
                return {
                    name: value,
                    locale: inputLocale
                }
            })
            const selectedLocales = childData.map(item => item.locale)
            for (const iterator of locales) {
                if (selectedLocales.indexOf(iterator.value) === -1)
                    childData.push({ ...childData.filter(item => item.locale === 'en')[0], locale: iterator.value })
            }
            const [searchId, ...remainingWalk] = idWalk
            const updatedTableData = [...topTableData]
            const { entry } = getEntryRecursive([...updatedIndexWalk], updatedTableData)
            const resp = await addChild({ child: childData, idWalk: remainingWalk, prefix: entry.id }, searchId, type.value)
            if (resp.success) {
                toast.success(`${type.value} data entered successfully`)
                closeModalHandler()
                entry.children = [resp.node, ...entry.children]
                entry.hasChildren = true
                entry.isExpanded = true
                setTableData(updatedTableData)
            }
            else
                throw new Error(resp.error)
        } catch (error) {
            toast.error(error.message)
        }
        setBtnClicked(false)
    }

    const onEnterHandler = (e) => {
        if (e.key === 'Enter' && !btnClicked)
            addChildBtnHandler()
    }

    return (
        <Modal size='lg' show={modalDataIndex !== null} onHide={closeModalHandler} centered backdrop='static'
            keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title>Add Child for</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form.Group controlId='formEnterValue'>
                    <Breadcrumb>
                        {breadItems}
                    </Breadcrumb>
                    <Form.Label>Enter a value</Form.Label>
                    {
                        rows.map((row, index) => (
                            <InputGroup className='mb-3' key={row.id}>
                                <Form.Control autoFocus onKeyDown={onEnterHandler} type='text' value={row.value} onChange={(e) => rowInputChangeHandler(index, e.target.value.trimStart())} placeholder='Enter a value...' />
                                <Select
                                    options={locales}
                                    value={row.locale}
                                    placeholder='Locales'
                                    isSearchable={false}
                                    onChange={option => localesChangeHandler(option, index)}
                                    isDisabled={row.locale?.isDefault}
                                />
                                {!row.locale?.isDefault && <Button variant='danger' onClick={() => removeRowHandler(index)}>Remove</Button>}
                            </InputGroup>
                        ))
                    }
                    {(rows.length < locales.length) &&
                        <Button variant='secondary' onClick={addRowHandler}>Add another value</Button>}
                </Form.Group>
            </Modal.Body>
            <Modal.Footer>
                <Button key='Close' variant='secondary' onClick={closeModalHandler}>
                    Close
                </Button>
                <Button disabled={btnClicked} key='Add Child' variant='success' onClick={addChildBtnHandler}>Add Child</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default AddChildModal